import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import { Page, Snackbar, Alert } from "@common-ui/ui";
import ViewProfilePage from "./pages/ViewProfilePage";
import ProfilePage from "./pages/ProfilePage";
import { Header } from "../../components/Header";
import { getUserProfileData } from "../../services";

export const UserProfile = ({ email }) => {
  const history = useHistory();

  const [isLoading, setIsLoading] = useState(false);
  const [hasError, setHasError] = useState(null);
  const [mode, setMode] = useState("view");
  const [userData, setUserData] = useState({});
  const [refreshData, setRefreshData] = useState(false);
  const [toastOpen, setToastOpen] = useState(false);

  const defaultOrg = useSelector(
    (state) => state.organization?.defaultOrganization?.id
  );
  let organizations = useSelector((state) => state.organization.organizations);

  useEffect(() => {
    const getData = async () => {
      setIsLoading(true);
      try {
        const { data } = await getUserProfileData();
        setMode("view");
        setUserData(data);
        setIsLoading(false);
      } catch (error) {
        if (error?.response?.status === 404) {
          setHasError(true);
          setIsLoading(false);
          history.push({
            pathname: "/create-user-profile",
          });
        } else {
          alert(error);
          console.log(error);
        }
      }
    };
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const getData = async () => {
      try {
        const { data } = await getUserProfileData();
        setUserData(data);

        setMode("view");
        setIsLoading(false);
      } catch (error) {
        alert(error);
        console.log(error);
      }
    };
    if (refreshData) {
      getData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refreshData]);

  return (
    <Page title="FlukeWorks">
      <Header xl name="My Profile" history={history} />
      {mode === "view" && (
        <ViewProfilePage
          isLoading={isLoading}
          userEmail={email}
          userData={userData}
          setMode={setMode}
          setRefreshData={setRefreshData}
          defaultOrg={defaultOrg}
        />
      )}
      {!hasError && mode === "edit" && (
        <>
          <ProfilePage
            email={email}
            isLoading={isLoading}
            mode={mode}
            setMode={setMode}
            userData={userData}
            setRefreshData={setRefreshData}
            setToastOpen={setToastOpen}
            defaultOrg={defaultOrg}
            orgs={organizations}
          />
          <Snackbar
            open={toastOpen}
            autoHideDuration={6000}
            onClose={() => setToastOpen(false)}
          >
            <Alert
              onClose={() => setToastOpen(false)}
              severity="success"
              sx={{ width: "100%" }}
              variant="filled"
            >
              Profile updated successfully.
            </Alert>
          </Snackbar>
        </>
      )}
    </Page>
  );
};
